var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModuleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "21.02px",
    viewBox: "0 0 18 21.02",
    style: {
      enableBackground: "new 0 0 18 21.02"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.34,0.14l8.5,8.22C17.94,8.46,18,8.59,18,8.73v11.78c0,0.28-0.22,0.51-0.5,0.51H11v-6H7v6H0.5c-0.28,0-0.5-0.23-0.5-0.51 V8.72c0-0.14,0.06-0.27,0.16-0.37l8.5-8.22C8.85-0.05,9.15-0.05,9.34,0.14z M9,1.21L1,8.94v11.05l5,0.02v-6h6v5.98h5V8.94L9,1.21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleIcon);
export default __webpack_public_path__ + "static/media/moduleIcon.4b4642172c8fe7091656c6ab6839158f.svg";
export { ForwardRef as ReactComponent };